import { STATUS } from "@/lib/api";

export const StatusBadge = ({ status, testId }) => {
  const s = STATUS[status] || STATUS.disponible;
  return (
    <span className={`inline-flex text-[11px] uppercase tracking-[0.15em] px-3 py-1 rounded-full font-medium ${s.cls}`} data-testid={testId}>
      {s.label}
    </span>
  );
};
